/**
 * URL utility functions
 */

/**
 * Resolve an asset path to a full URL.
 * Returns the path unchanged if it's already an absolute URL (http/https),
 * otherwise joins it to REACT_APP_IMAGE_BASE_URL with exactly one slash.
 *
 * @param {string} path - Asset path or full URL
 * @returns {string} Resolved URL (empty string if path is falsy)
 */
export function resolveAssetUrl(path) {
  if (!path) return '';
  if (/^https?:\/\//i.test(path)) return path;
  const base = process.env.REACT_APP_IMAGE_BASE_URL || '';
  if (!base) return path;
  const baseTrimmed = base.endsWith('/') ? base.slice(0, -1) : base;
  const pathPrefixed = path.startsWith('/') ? path : `/${path}`;
  return `${baseTrimmed}${pathPrefixed}`;
}
